var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2269"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2269"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.38784",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};